import { NgModule } from "@angular/core";
import { KwikUISafeHtmlPipe } from "./safe-html.pipe";

@NgModule({
  declarations: [KwikUISafeHtmlPipe],
  exports: [KwikUISafeHtmlPipe]
})
export class KwikUISafeHtmlPipeModule {}
